<mat-toolbar>
    <span>Asignación de Responsables</span>
    <span class="spacer"></span>
</mat-toolbar>
<div class="p-5 bg-white w-full">
    <form [formGroup]="formAsigResp">
        <div class="flex p-5 pt-2 pb-2 flex-row justify-between items-center">
            <div>
                <mat-slide-toggle formControlName="banEntregables" color="primary" class="mr-5">Entregables</mat-slide-toggle>
                <mat-slide-toggle formControlName="seguimiento" color="primary">Seguimiento</mat-slide-toggle>
            </div>
            <div class="mr-5">
                <button mat-flat-button color="warn" class="mr-1" (click)="changeTab()" 
                    [disabled]="
                        (
                            formAsigResp.get('analista')?.value == '' ||
                            formAsigResp.get('supervisor')?.value == '' || 
                            formAsigResp.get('coordinador')?.value == '' || 
                            !formAsigResp.get('banEntregables')?.value
                        )">
                    ENTREGABLES
                </button>
                <button mat-flat-button color="primary" (click)="restaurar()" [disabled]="deshabilitado" *ngIf="edicion">RESTAURAR</button>
            </div>
        </div>
        <div class="flex p-5 pb-0">
            <mat-form-field class="!w-full mr-5">
                <mat-label>Justificación de seguimiento</mat-label>
                <input type="text" matInput formControlName="seguimiento_justificacion" #seguimiento_justificacion maxlength="100">
                <mat-hint align="end">{{seguimiento_justificacion.value.length}} / 100</mat-hint>
                @if(formAsigResp.controls["seguimiento_justificacion"].hasError('required')) {
                    <mat-error>Campo obligatorio.</mat-error>
                }
            </mat-form-field>
        </div>

        <div class="flex p-5 pb-0">
            <mat-form-field class="w-1/3 pr-5">
                <mat-label>Analista</mat-label>
                <mat-select formControlName="analista">
                @for (item of catAnalista; track item.id) {
                    @if(item.temas_permiso.includes(oEntrada.tema)) {
                        <mat-option [value]="item.id" [disabled]="item.disabled">{{ item.nombre }}</mat-option>
                    } @else if(item.id == oEntrada.analista) {
                        <mat-option [value]="item.id" disabled>{{ item.nombre }}</mat-option>
                    }
                }
                </mat-select>
                @if(formAsigResp.controls["analista"].hasError('required')) {
                    <mat-error>Campo obligatorio.</mat-error>
                }
            </mat-form-field>
            <mat-form-field class="w-1/3 pr-5">
                <mat-label>Supervisor</mat-label>
                <mat-select formControlName="supervisor">
                    @for (item of catSupervisor; track item.id) {
                        @if(item.temas_permiso.includes(oEntrada.tema)) {
                            <mat-option [value]="item.id" [disabled]="item.disabled">{{ item.nombre }}</mat-option>
                        } @else if(item.id == oEntrada.supervisor) {
                            <mat-option [value]="item.id" disabled>{{ item.nombre }}</mat-option>
                        }
                    }
                </mat-select>
                @if(formAsigResp.controls["supervisor"].hasError('required')) {
                    <mat-error>Campo obligatorio.</mat-error>
                }
            </mat-form-field>
            <mat-form-field class="w-1/3 pr-5">
                <mat-label>Coordinador</mat-label>
                <mat-select formControlName="coordinador">
                    @for (item of catCoordinador; track item.id) {
                        @if(item.temas_permiso.includes(oEntrada.tema)) {
                            <mat-option [value]="item.id" [disabled]="item.disabled">{{ item.nombre }}</mat-option>
                        } @else if(item.id == oEntrada.coordinador) {
                            <mat-option [value]="item.id" disabled>{{ item.nombre }}</mat-option>
                        }
                    }
                </mat-select>
                @if(formAsigResp.controls["coordinador"].hasError('required')) {
                    <mat-error>Campo obligatorio.</mat-error>
                }
            </mat-form-field>
        </div>
    </form>
</div>